import {useFormInputLabelWithSuffix} from '@hconnect/common/hooks'
import {EquipmentData, EquipmentIdType} from '@hconnect/common/types'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {COMMON_SHIFT_EVENT_WIDGET_NAMESPACE} from '../../consts'

import {MainEquipmentSearchHierarchy} from './MainEquipmentSearchHierarchy'

type Props = {
  plantId: string
  errorText?: React.ReactNode
  onChange: (equipment: EquipmentData | undefined) => void
  value: EquipmentData | undefined
  required?: boolean
  disabled?: boolean
  idType?: EquipmentIdType
}

export const EventMainEquipmentSearchHierarchy = (props: Props) => {
  const {t} = useTranslation(COMMON_SHIFT_EVENT_WIDGET_NAMESPACE)

  const label = useFormInputLabelWithSuffix({
    label: t('shiftEvent.label.mainEquipment'),
    optional: !props.required,
    optionalTKey: t('shiftEvent.label.optional')
  })

  return <MainEquipmentSearchHierarchy label={label} {...props} />
}
